import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const Loader = () => {
    return (
        <div
            style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 9999,
            }}
        >
            <CircularProgress size={80} thickness={2.8} />
        </div>
    );
};

export default Loader;
